import { useState, useEffect } from 'react'

const ALL_UPDATE_IDS = [
  'u27','u26','u25','u24','u23','u22','u21','u20','u19','u18','u17','u16',
  'u15','u14','u13','u12','u11','u10','u9','u8','u7','u6','u5','u4','u3','u2','u1',
]

function computeUnread(): number {
  const readIds = new Set<string>(JSON.parse(localStorage.getItem('beacon_read_update_ids') || '[]'))
  return ALL_UPDATE_IDS.filter((id) => !readIds.has(id)).length
}

export function useBellUnread(): number {
  const [count, setCount] = useState(computeUnread)
  useEffect(() => {
    function onRead() { setCount(computeUnread()) }
    window.addEventListener('beacon-updates-read', onRead)
    return () => window.removeEventListener('beacon-updates-read', onRead)
  }, [])
  return count
}
